// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11dc9550","581":"7ce96e62"}[chunkId] + ".chunk.js";
};